import { attributesTableService } from "@/services/layers/attributesTable.js";

export const normalizeGeometryFamily = (rawType = "") => {
  const value = String(rawType).trim().toLowerCase();
  if (!value) return null;
  if (/raster/.test(value)) return "raster";
  if (/(polygon|surface)/.test(value)) return "polygon";
  if (/(linestring|polyline|curve|line)/.test(value)) return "line";
  if (/point/.test(value)) return "point";
  return null;
};

const resolveGeoServerRasterFamily = async layer => {
  const geoserverData = layer.provider.geoserverdata || {};
  if (!geoserverData.workspace || !geoserverData.datastore) return null;

  const response = await fetch(`${process.env.VUE_APP_API_URL}api/v1/geoserver/layerType`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      workspace: geoserverData.workspace,
      datastore: geoserverData.datastore,
      url: layer.provider.url,
    }),
  });
  if (!response.ok) return null;
  const data = await response.json();
  return normalizeGeometryFamily(data.layerType);
};

export const storedGeometryFamily = layer => normalizeGeometryFamily(
  layer && (layer.geometry_type || layer.geometryType)
);

// Las capas nuevas guardan geometry_type. Esta resolución queda como respaldo
// para documentos antiguos y reutiliza el cache de metadata del visor.
export const resolveLayerGeometryFamily = async (layer, options = {}) => {
  const { preferStored = true, timeoutMs = 5000 } = options;
  const storedFamily = storedGeometryFamily(layer);
  if (preferStored && storedFamily) return storedFamily;
  if (!layer || !layer.provider || !layer.provider.url) return null;

  // En datos históricos, "file" representa capas servidas por GeoServer.
  // DescribeFeatureType parte desde la raíz del servicio, no desde /wms.
  const providerName = layer.provider.name === "file" ? "geoserver" : layer.provider.name;
  const providerUrl = providerName === "geoserver"
    ? String(layer.provider.url).replace(/[?#].*$/, "").replace(/\/(?:wms|wfs)\/?$/i, "")
    : layer.provider.url;
  const metadataLayer = {
    ...layer,
    provider: { ...layer.provider, name: providerName, url: providerUrl },
  };
  if (/\/ImageServer(?:\/\d+)?\/?$/i.test(providerUrl)) return "raster";
  let timeoutId;
  const timeout = new Promise((resolve) => {
    timeoutId = setTimeout(() => resolve(null), timeoutMs);
  });
  let metadata;
  try {
    metadata = await Promise.race([
      attributesTableService.getLayerMetadata(metadataLayer, !preferStored),
      timeout,
    ]);
  } catch (error) {
    if (providerName !== "geoserver") throw error;
  } finally {
    clearTimeout(timeoutId);
  }
  const metadataFamily = normalizeGeometryFamily(metadata && (metadata.geometryFamily || metadata.geometryType));
  if (metadataFamily || providerName !== "geoserver") return metadataFamily;
  return resolveGeoServerRasterFamily(metadataLayer);
};
